import { matchPath } from 'react-router-dom';
import type { ScreenName } from './events';

const ROUTE_SCREENS: ReadonlyArray<readonly [string, ScreenName]> = [
  ['/home', 'home'],
  ['/login', 'login'],
  ['/region', 'region'],
  ['/prescriptions', 'prescription_list'],
  ['/prescriptions/:id', 'prescription_detail'],
  ['/catalog', 'catalog'],
  ['/catalog/search', 'search'],
  ['/catalog/products/:productId', 'product'],
  ['/cart', 'cart'],
  ['/cart/:pharmacyId', 'cart_pharmacy'],
  ['/cart/:pharmacyId/checkout', 'checkout'],
  ['/orders', 'order_list'],
  ['/orders/:id', 'order_detail'],
  ['/profile', 'profile'],
  ['/profile/relatives', 'relatives'],
  ['/profile/relatives/add', 'relative_form'],
  ['/profile/relatives/edit', 'relative_form'],
  ['/profile/support', 'support'],
  ['/profile/faq', 'faq'],
  ['/error', 'error'],
];

/**
 * Экран и нормализованный путь для отчёта: id в пути заменяются на :id.
 * Роуты без экрана (`/`, `/esia-callback`) — технические переходы, просмотром
 * не считаются, к тому же в URL callback лежат параметры ЕСИА
 */
export function resolveScreen(
  pathname: string,
  search = ''
): { screen: ScreenName; path: string } | null {
  // Вкладка аптек каталога шлёт свои экраны сама: pharmacy_list / pharmacy_map
  if (
    pathname === '/catalog' &&
    new URLSearchParams(search).get('tab') === 'pharmacies'
  ) {
    return null;
  }

  for (const [pattern, screen] of ROUTE_SCREENS) {
    if (matchPath(pattern, pathname)) {
      return { screen, path: pattern.replace(/:[^/]+/g, ':id') };
    }
  }

  return null;
}
